var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidemenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0338 13.3334C11.0338 12.643 11.5935 12.0834 12.2838 12.0834H20.6171C21.3075 12.0834 21.8671 12.643 21.8671 13.3334C21.8671 14.0237 21.3075 14.5834 20.6171 14.5834H12.2838C11.5935 14.5834 11.0338 14.0237 11.0338 13.3334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0338 20C11.0338 19.3096 11.5935 18.75 12.2838 18.75H28.9505C29.6408 18.75 30.2005 19.3096 30.2005 20C30.2005 20.6904 29.6408 21.25 28.9505 21.25H12.2838C11.5935 21.25 11.0338 20.6904 11.0338 20Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3672 26.6667C19.3672 25.9764 19.9268 25.4167 20.6172 25.4167L28.9505 25.4167C29.6409 25.4167 30.2005 25.9764 30.2005 26.6667C30.2005 27.3571 29.6409 27.9167 28.9505 27.9167L20.6172 27.9167C19.9268 27.9167 19.3672 27.3571 19.3672 26.6667Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidemenu);
export default __webpack_public_path__ + "static/media/sidemenu.76ab02daee1e9a411a52257af52e967d.svg";
export { ForwardRef as ReactComponent };